import { ApplicationStatus, ScreeningStatus } from "shared/types";
import { NO_UNIT_TYPE } from "../constants";

export const getFilterDisplayName = (filter: string) => {
  switch (filter) {
    case NO_UNIT_TYPE:
      return "—";
    case ApplicationStatus.Pending:
      return "Invited";
    case ApplicationStatus.Approved:
      return "Approved";
    case ApplicationStatus.ConditionalApproved:
      return "Approved conditionally";
    case ApplicationStatus.Rejected:
      return "Declined";
    case ApplicationStatus.Submitted:
      return "Pending decision";
    case ApplicationStatus.Started:
      return "In progress";
    case ApplicationStatus.Canceled:
      return "Canceled";
    case ScreeningStatus.Completed:
      return "Complete";
    case ScreeningStatus.Failed:
      return "Error";
    case ScreeningStatus.Processing:
      return "In progress";
    case ScreeningStatus.NotStarted:
      return "Not started";
    case ScreeningStatus.Reverifying:
      return "Re-verifying";
    default:
      return filter;
  }
};
